import type { ComposerEditorMentionProps } from '@liveblocks/react-ui/primitives'
import { Composer } from '@liveblocks/react-ui/primitives'

import { Tooltip } from '@/components/lemmala-design-system/tooltip/tooltip'

import { UserName } from './user-name'

export const EditorMention = ({ mention }: ComposerEditorMentionProps) => (
  <Tooltip
    asChild
    triggerClassName='inline'
    trigger={
      <Composer.Mention className='font-medium text-main-foreground-accent'>
        @<UserName userId={mention.id} />
      </Composer.Mention>
    }
  >
    {mention.id}
  </Tooltip>
)
